$(function(){
    //open-close share social btns
    var socialLinks = $('.social-block__links');
    var socilaCaret = $('.social-btn__caret'); 


    $('.social-btn__caret, .social-btn__share').click(function(){
        if(socilaCaret.hasClass('social-btn__caret--closed')){
            socialLinks.show({ direction: "left" }, 300);
            socilaCaret.removeClass('social-btn__caret--closed');
        } else {
            socialLinks.hide({ direction: "left" }, 300);
            socilaCaret.addClass('social-btn__caret--closed');
        }

    })

    //open/close mobile-menu 

    $('.main-menu__open, .main-menu__close').click(function(){
        $('.main-menu__content').slideToggle();
    });

    //select the pay in search form

    $('.search-form__list li').click(function(){
        $('#payList').html($(this).html());
        $('#countrySelect').val($(this).attr('data-value'));
    });

    //form contact in header

    //classs name added to form user-account_item__active
    $('.user-account__items > .user-account_item').click(function(e){
        e.preventDefault();
        var theId = $(this).attr('id'), isActive = false;

        if($(this).hasClass('texte-yellow-active')) {
            isActive = true;
        }
        $('.user-account__items > .user-account_item').removeClass('texte-yellow-active');

        // change color on li
        if(isActive) {
            $(this).removeClass('texte-yellow-active');
        } else {
            $(this).addClass('texte-yellow-active');
        }

        //change classes
        if (!isActive && theId === "js_inscription") {
            $('.user-account__form').addClass('open');
        } else {
            $('.user-account__form').removeClass('open');
        }

        if (!isActive && theId === "js_connexion") {
            $('.user-connect__form').addClass('open');
        } else {
            $('.user-connect__form').removeClass('open');
        }
    });

    // All the popover
    $('[data-toggle="popover"]').popover();
    $('.user-action__btn.signaler').on('show.bs.popover', function () {
        $('.popover.ecrire').popover('hide');
    });
    $('.user-action__btn.ecrire').on('show.bs.popover', function () {
        $('.popover.signaler').popover('hide');
    });
    $('body').on('hidden.bs.popover', function (e) {
        $(e.target).data("bs.popover").inState.click = false;
    });
    $('.part-right-user-action').on('click', '.popover.signaler .popover-title span', function () {
        $('.popover.signaler').popover('hide');
    });
    $('.part-right-user-action').on('click', '.popover.ecrire .popover-title span', function () {
        $('.popover.ecrire').popover('hide');
    });

    $("#print").click(function() {
        window.print();
    });
});
